// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5001';

// Other configuration constants can be added here
export const MAX_UPLOAD_SIZE = 5 * 1024 * 1024; // 5MB in bytes
export const SUPPORTED_RESUME_FORMATS = ['.pdf', '.doc', '.docx'];

// Bulk Upload Configuration
export const MAX_BULK_UPLOAD_FILES = 10; // Maximum number of files in a single bulk upload
export const BULK_UPLOAD_TIMEOUT = 30000; // 30 seconds timeout for each file processing
export const EVALUATION_TIMEOUT = 10000; // 10 seconds timeout for each evaluation

// API Endpoints
export const ENDPOINTS = {
    // Auth
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    RESET_PASSWORD: '/auth/reset-password',
    UPDATE_PASSWORD: '/auth/update-password',
    
    // Jobs
    JOBS: '/jobs',
    CREATE_JOB: '/jobs/create',
    JOB_DETAILS: (jobId) => `/jobs/${jobId}`,
    
    // Applicants
    APPLICANTS: (jobId) => `/applicants/${jobId}`,
    APPLICANTS_FOR_JOB: (jobId) => `/applicants/job/${jobId}`,
    CANDIDATE_DETAILS: (candidateId) => `/applicants/candidate/${candidateId}`,
    APPLICATION_STATUS: (applicationId) => `/applicants/status/${applicationId}`,
    APPLICATION_SOURCE: (applicationId) => `/applicants/source/${applicationId}`,
    EXTRACT_FIELDS: '/applicants/extract-fields',
    SEARCH_JOBSEEKERS: '/applicants/search',
    DOWNLOAD_RESUME: (jobseekerId) => `/applicants/resume/${jobseekerId}`,
    COMPARE_CANDIDATES: '/applicants/compare',
    
    // AI
    EVALUATE_MATCH: '/ai/evaluate-match',
    GENERATE_CONTENT: '/ai/generate-content',
    DUMMY_APPLICANT: (jobId) => `/ai/dummy-applicant/${jobId}`,
    
    // Audit
    AUDIT_LOGIN: '/audit/login',
    AUDIT_LOGIN_HISTORY: (userId) => `/audit/login-history/${userId}`,
    
    // Admin - Login Analytics
    ADMIN_LOGIN_STATS: '/admin/stats/logins/daily',
    
    // Notes
    JOB_NOTE: (noteId) => `/applicants/jobnote/${noteId}`,
    APPLICATION_NOTE: (noteId) => `/applicants/applicationnote/${noteId}`,
    
    // Recruiter Sources
    RECRUITER_SOURCES: '/recruiter-sources',
    RECRUITER_SOURCES_SEARCH: (query) => `/recruiter-sources/search?query=${encodeURIComponent(query)}`,
    RECRUITER_SOURCE: (sourceId) => `/recruiter-sources/${sourceId}`
}; 